/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var jisonLdpatch = (function(){
    var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,18],$V1=[1,19],$V2=[1,17],$V3=[1,20],$V4=[1,21],$V5=[1,22],$V6=[1,23],$V7=[1,24],$V8=[5,32,33,34,35,36,37,38,39],$V9=[1,28],$Va=[1,39],$Vb=[5,32,33,34,35,36,37,38,39,49,50],$Vc=[1,66],$Vd=[1,61],$Ve=[1,62],$Vf=[1,63],$Vg=[1,65],$Vh=[1,64],$Vi=[29,42,45,49,55,58,59,60,61];
    var parser = {trace: function trace () { },
    yy: {},
    symbols_: {"error":2,"expressions":3,"patchList":4,"EOF":5,"patch":6,"noop":7,"deleteResource":8,"insertResource":9,"addIri":10,"deleteIri":11,"addLiteral":12,"deleteLiteral":13,"replaceLiteralIri":14,"replaceIriLiteral":15,"replaceIriIri":16,"updateIriIri":17,"updateLiteralLiteral":18,"updateList":19,"tripleList":20,"triple":21,"iriTriple":22,"literalTriple":23,"blankNodeTriple":24,"blankNodeLiteralTriple":25,"blankNodeSubject":26,"blankNodeSubjectObject":27,"iri":28,"PERIOD":29,"blankNode":30,"literal":31,"DELETERESOURCE":32,"INSERTRESOURCE":33,"NOOP":34,"ADD":35,"DELETE":36,"REPLACE":37,"UPDATE":38,"UPDATELIST":39,"slice":40,"list":41,"UNSIGNEDINTEGER":42,"SLICEDIVIDER":43,"LEFTPAREN":44,"RIGHTPAREN":45,"iriList":46,"literalList":47,"object":48,"IRIREFCONT":49,"BLANKNODE":50,"rdfLiteral":51,"decimalLiteral":52,"booleanLiteral":53,"integerLiteral":54,"LITERAL":55,"LANGTAG":56,"DATATYPEFLAG":57,"SIGNEDDECIMAL":58,"UNSIGNEDDECIMAL":59,"INTEGER":60,"BOOLEAN":61,"$accept":0,"$end":1},
    terminals_: {2:"error",5:"EOF",29:"PERIOD",32:"DELETERESOURCE",33:"INSERTRESOURCE",34:"NOOP",35:"ADD",36:"DELETE",37:"REPLACE",38:"UPDATE",39:"UPDATELIST",42:"UNSIGNEDINTEGER",43:"SLICEDIVIDER",44:"LEFTPAREN",45:"RIGHTPAREN",49:"IRIREFCONT",50:"BLANKNODE",55:"LITERAL",56:"LANGTAG",57:"DATATYPEFLAG",58:"SIGNEDDECIMAL",59:"UNSIGNEDDECIMAL",60:"INTEGER",61:"BOOLEAN"},
    productions_: [0,[3,2],[4,2],[4,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[20,2],[20,1],[21,1],[21,1],[21,1],[21,1],[21,1],[21,1],[22,4],[24,4],[26,4],[27,4],[23,4],[25,4],[8,3],[9,2],[7,1],[10,5],[12,5],[11,5],[13,5],[14,7],[15,7],[16,7],[17,6],[18,6],[19,6],[40,3],[40,2],[40,2],[40,1],[41,2],[41,3],[41,3],[48,1],[48,1],[46,2],[46,1],[47,2],[47,1],[28,1],[30,1],[31,1],[31,1],[31,1],[31,1],[51,1],[51,2],[51,3],[52,1],[52,1],[54,1],[54,1],[53,1]],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
    /* this == yyval */
    
    var $0 = $$.length - 1;
    switch (yystate) {
    case 1:
    return this.$;
    break;
    case 17:
    
                                                this.$ = [$$[$0-1], ...$$[$0]];
                                            
    break;
    case 18:
    
                                                this.$ = [$$[$0]];
                                            
    break;
    case 19: case 20: case 21: case 22: case 23: case 24:
    
                                                this.$ = $$[$0];
                                            
    break;
    case 25: case 26: case 27: case 28: case 29: case 30:
    
                                                this.$ = [$$[$0-3], $$[$0-2], $$[$0-1]];
                                            
    break;
    case 31:
    
                                                this.$ = $$[$0-1];
                                                if (yy.hasOwnProperty('deleteResource')) {
                                                    yy.deleteResource($$[$0-1]);
                                                }
                                            
    break;
    case 32:
    
                                                this.$ = $$[$0];
                                                if (yy.hasOwnProperty('insertResource')) {
                                                    yy.insertResource($$[$0]);
                                                }
                                            
    break;
    case 33:
    
                                                if (yy.hasOwnProperty('addNoop')) {
                                                    yy.addNoop();
                                                }
                                            
    break;
    case 34:
    
                                                this.$ = $$[$0-3] + " " + $$[$0-2] + " " + $$[$0-1];
                                                if (yy.hasOwnProperty('addIri')) {
                                                    yy.addIri($$[$0-3], $$[$0-2], $$[$0-1]);
                                                }
                                            
    break;
    case 35:
    
                                                this.$ = $$[$0-3] + " " + $$[$0-2] + " " + $$[$0-1];
                                                if (yy.hasOwnProperty('addLiteral')) {
                                                    yy.addLiteral($$[$0-3], $$[$0-2], $$[$0-1]);
                                                }
                                            
    break;
    case 36:
    
                                                this.$ = $$[$0-3] + " " + $$[$0-2] + " " + $$[$0-1];
                                                if (yy.hasOwnProperty('deleteIri')) {
                                                    yy.deleteIri($$[$0-3], $$[$0-2], $$[$0-1]);
                                                }
                                            
    break;
    case 37:
    
                                                this.$ = $$[$0-3] + " " + $$[$0-2] + " " + $$[$0-1];
                                                if (yy.hasOwnProperty('deleteLiteral')) {
                                                    yy.deleteLiteral($$[$0-3], $$[$0-2], $$[$0-1]);
                                                }
                                            
    break;
    case 38:
    
                                                this.$ = $$[$0-5] + " " + $$[$0-4] + " " + $$[$0-3] + " " + $$[$0-2] + " " + $$[$0-1];
                                                if (yy.hasOwnProperty('replaceLiteralIri')) {
                                                    yy.replaceLiteralIri($$[$0-5], $$[$0-4], $$[$0-3], $$[$0-2], $$[$0-1]);
                                                }
                                            
    break;
    case 39:
    
                                                this.$ = $$[$0-5] + " " + $$[$0-4] + " " + $$[$0-3] + " " + $$[$0-2] + " " + $$[$0-1];
                                                if (yy.hasOwnProperty('replaceIriLiteral')) {
                                                    yy.replaceIriLiteral($$[$0-5], $$[$0-4], $$[$0-3], $$[$0-2], $$[$0-1]);
                                                }
                                            
    break;
    case 40:
    
                                                this.$ = $$[$0-5] + " " + $$[$0-4] + " " + $$[$0-3] + " " + $$[$0-2] + " " + $$[$0-1];
                                                if (yy.hasOwnProperty('replaceIriIri')) {
                                                    yy.replaceIriIri($$[$0-5], $$[$0-4], $$[$0-3], $$[$0-2], $$[$0-1]);
                                                }
                                            
    break;
    case 41:
    
                                                this.$ = $$[$0-4] + " " + $$[$0-3] + " " + $$[$0-2] + " " + $$[$0-1];
                                                if (yy.hasOwnProperty('updateIriIri')) {
                                                    yy.updateIriIri($$[$0-4], $$[$0-3], $$[$0-2], $$[$0-1]);
                                                }
                                            
    break;
    case 42:
    
                                                this.$ = $$[$0-4] + " " + $$[$0-3] + " " + $$[$0-2] + " " + $$[$0-1];
                                                if (yy.hasOwnProperty('updateLiteralLiteral')) {
                                                    yy.updateLiteralLiteral($$[$0-4], $$[$0-3], $$[$0-2], $$[$0-1]);
                                                }
                                            
    break;
    case 43:
    
                                            this.$ = $$[$0-4] + " " + $$[$0-3] + " " + $$[$0-2] + " " + $$[$0-1];
                                            if (yy.hasOwnProperty('updateList')) {
                                                yy.updateList($$[$0-4], $$[$0-3], $$[$0-2], $$[$0-1]);
                                            }
                                        
    break;
    case 44:
    
                                            this.$ = $$[$0-2] + $$[$0-1] + $$[$0];
                                        
    break;
    case 45: case 46:
    
                                            this.$ = $$[$0-1] + $$[$0];
                                        
    break;
    case 47:
    
                                            this.$ = $$[$0];
                                        
    break;
    case 48:
    
                                            this.$ = [];
                                        
    break;
    case 49: case 50:
    
                                            this.$ = $$[$0-1];
                                        
    break;
    case 53: case 55:
    
                                            this.$ = [$$[$0-1], ...$$[$0]];
                                        
    break;
    case 54: case 56:
    
                                            this.$ = [$$[$0]];
                                        
    break;
    case 57:
    
                                            const stripped0 = $$[$0].substring(1, $$[$0].length - 1);
                                            this.$ = stripped0;
                                        
    break;
    case 58:
    
                                            this.$ = ["BlankNode", $$[$0], null, null];
                                        
    break;
    case 60:
    
                                            this.$ = ["DecimalLiteral", $$[$0], null, "http://www.w3.org/2001/XMLSchema#decimal"];
                                        
    break;
    case 61:
    
                                            this.$ = ["BooleanLiteral", $$[$0], null, "http://www.w3.org/2001/XMLSchema#boolean"];
                                        
    break;
    case 62:
    
                                            this.$ = ["IntegerLiteral", $$[$0], null, "http://www.w3.org/2001/XMLSchema#integer"];
                                        
    break;
    case 63:
    
                                            const stripped1 = $$[$0].substring(1, $$[$0].length - 1);
                                            this.$ = ["Literal", stripped1, null, null];
                                        
    break;
    case 64:
    
                                            const stripped2 = $$[$0-1].substring(1, $$[$0-1].length - 1);
                                            const strippedLang2 = $$[$0].substring(1);
                                            this.$ = ["LangLiteral", stripped2, strippedLang2, null];
                                        
    break;
    case 65:
    
                                            const stripped3 = $$[$0-2].substring(1, $$[$0-2].length - 1);
                                            const strippedDatatype3 = $$[$0];
                                            this.$ = ["DataTypeLiteral", stripped3, null, strippedDatatype3];
                                        
    break;
    }
    },
    table: [{3:1,4:2,6:3,7:4,8:5,9:6,10:7,11:8,12:9,13:10,14:11,15:12,16:13,17:14,18:15,19:16,32:$V0,33:$V1,34:$V2,35:$V3,36:$V4,37:$V5,38:$V6,39:$V7},{1:[3]},{5:[1,25],6:26,7:4,8:5,9:6,10:7,11:8,12:9,13:10,14:11,15:12,16:13,17:14,18:15,19:16,32:$V0,33:$V1,34:$V2,35:$V3,36:$V4,37:$V5,38:$V6,39:$V7},o($V8,[2,3]),o($V8,[2,4]),o($V8,[2,5]),o($V8,[2,6]),o($V8,[2,7]),o($V8,[2,8]),o($V8,[2,9]),o($V8,[2,10]),o($V8,[2,11]),o($V8,[2,12]),o($V8,[2,13]),o($V8,[2,14]),o($V8,[2,15]),o($V8,[2,16]),o($V8,[2,33]),{28:27,49:$V9},{20:29,21:30,22:31,23:32,24:33,25:34,26:35,27:36,28:37,30:38,49:$V9,50:$Va},{28:40,49:$V9},{28:41,49:$V9},{28:42,49:$V9},{28:43,49:$V9},{28:44,49:$V9},{1:[2,1]},o($V8,[2,2]),{29:[1,45]},o([29,42,43,45,49,50,55,58,59,60,61],[2,57]),o($V8,[2,32]),o($V8,[2,18],{21:30,22:31,23:32,24:33,25:34,26:35,27:36,28:37,30:38,20:46,49:$V9,50:$Va}),o($Vb,[2,19]),o($Vb,[2,20]),o($Vb,[2,21]),o($Vb,[2,22]),o($Vb,[2,23]),o($Vb,[2,24]),{28:47,49:$V9},{28:48,49:$V9},o([29,49],[2,58]),{28:49,49:$V9},{28:50,49:$V9},{28:51,49:$V9},{28:52,49:$V9},{28:53,49:$V9},o($V8,[2,31]),o($V8,[2,17]),{28:54,30:56,31:55,42:$Vc,49:$V9,50:$Va,51:57,52:58,53:59,54:60,55:$Vd,58:$Ve,59:$Vf,60:$Vg,61:$Vh},{28:68,30:69,31:67,42:$Vc,49:$V9,50:$Va,51:57,52:58,53:59,54:60,55:$Vd,58:$Ve,59:$Vf,60:$Vg,61:$Vh},{28:70,31:71,42:$Vc,49:$V9,51:57,52:58,53:59,54:60,55:$Vd,58:$Ve,59:$Vf,60:$Vg,61:$Vh},{28:72,31:73,42:$Vc,49:$V9,51:57,52:58,53:59,54:60,55:$Vd,58:$Ve,59:$Vf,60:$Vg,61:$Vh},{28:75,31:74,42:$Vc,49:$V9,51:57,52:58,53:59,54:60,55:$Vd,58:$Ve,59:$Vf,60:$Vg,61:$Vh},{28:76,31:77,42:$Vc,49:$V9,51:57,52:58,53:59,54:60,55:$Vd,58:$Ve,59:$Vf,60:$Vg,61:$Vh},{40:78,42:[1,79],43:[1,80]},{29:[1,81]},{29:[1,82]},{29:[1,83]},o($Vi,[2,59]),o($Vi,[2,60]),o($Vi,[2,61]),o($Vi,[2,62]),o($Vi,[2,63],{56:[1,84],57:[1,85]}),o($Vi,[2,66]),o($Vi,[2,67]),o($Vi,[2,70]),o($Vi,[2,68]),o($Vi,[2,69]),{29:[1,86]},{29:[1,87]},{29:[1,88]},{29:[1,89]},{29:[1,90]},{29:[1,91]},{29:[1,92]},{28:93,49:$V9},{28:94,49:$V9},{28:95,49:$V9},{31:96,42:$Vc,51:57,52:58,53:59,54:60,55:$Vd,58:$Ve,59:$Vf,60:$Vg,61:$Vh},{41:97,44:[1,98]},{43:[1,99]},{42:[1,100],44:[2,47]},o($Vb,[2,25]),o($Vb,[2,29]),o($Vb,[2,26]),o($Vi,[2,64]),{28:101,49:$V9},o($Vb,[2,30]),o($Vb,[2,27]),o($Vb,[2,28]),o($V8,[2,34]),o($V8,[2,35]),o($V8,[2,36]),o($V8,[2,37]),{28:102,49:$V9},{28:104,31:103,42:$Vc,49:$V9,51:57,52:58,53:59,54:60,55:$Vd,58:$Ve,59:$Vf,60:$Vg,61:$Vh},{29:[1,105]},{29:[1,106]},{29:[1,107]},{28:111,31:112,42:$Vc,45:[1,108],46:109,47:110,49:$V9,51:57,52:58,53:59,54:60,55:$Vd,58:$Ve,59:$Vf,60:$Vg,61:$Vh},{42:[1,113],44:[2,46]},{44:[2,45]},o($Vi,[2,65]),{29:[1,114]},{29:[1,115]},{29:[1,116]},o($V8,[2,41]),o($V8,[2,42]),o($V8,[2,43]),{29:[2,48]},{45:[1,117]},{45:[1,118]},{28:111,45:[2,54],46:119,49:$V9},{31:112,42:$Vc,45:[2,56],47:120,51:57,52:58,53:59,54:60,55:$Vd,58:$Ve,59:$Vf,60:$Vg,61:$Vh},{44:[2,44]},o($V8,[2,38]),o($V8,[2,39]),o($V8,[2,40]),{29:[2,49]},{29:[2,50]},{45:[2,53]},{45:[2,55]}],
    defaultActions: {25:[2,1],100:[2,45],108:[2,48],113:[2,44],117:[2,49],118:[2,50],119:[2,53],120:[2,55]},
    parseError: function parseError (str, hash) {
        if (hash.recoverable) {
            this.trace(str);
        } else {
            var error = new Error(str);
            error.hash = hash;
            throw error;
        }
    },
    parse: function parse(input) {
        var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
        var args = lstack.slice.call(arguments, 1);
        var lexer = Object.create(this.lexer);
        var sharedState = { yy: {} };
        for (var k in this.yy) {
            if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
                sharedState.yy[k] = this.yy[k];
            }
        }
        lexer.setInput(input, sharedState.yy);
        sharedState.yy.lexer = lexer;
        sharedState.yy.parser = this;
        if (typeof lexer.yylloc == 'undefined') {
            lexer.yylloc = {};
        }
        var yyloc = lexer.yylloc;
        lstack.push(yyloc);
        var ranges = lexer.options && lexer.options.ranges;
        if (typeof sharedState.yy.parseError === 'function') {
            this.parseError = sharedState.yy.parseError;
        } else {
            this.parseError = Object.getPrototypeOf(this).parseError;
        }
        function popStack(n) {
            stack.length = stack.length - 2 * n;
            vstack.length = vstack.length - n;
            lstack.length = lstack.length - n;
        }
        _token_stack:
            var lex = function () {
                var token;
                token = lexer.lex() || EOF;
                if (typeof token !== 'number') {
                    token = self.symbols_[token] || token;
                }
                return token;
            };
        var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
        while (true) {
            state = stack[stack.length - 1];
            if (this.defaultActions[state]) {
                action = this.defaultActions[state];
            } else {
                if (symbol === null || typeof symbol == 'undefined') {
                    symbol = lex();
                }
                action = table[state] && table[state][symbol];
            }
                        if (typeof action === 'undefined' || !action.length || !action[0]) {
                    var errStr = '';
                    expected = [];
                    for (p in table[state]) {
                        if (this.terminals_[p] && p > TERROR) {
                            expected.push('\'' + this.terminals_[p] + '\'');
                        }
                    }
                    if (lexer.showPosition) {
                        errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                    } else {
                        errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                    }
                    this.parseError(errStr, {
                        text: lexer.match,
                        token: this.terminals_[symbol] || symbol,
                        line: lexer.yylineno,
                        loc: yyloc,
                        expected: expected
                    });
                }
            if (action[0] instanceof Array && action.length > 1) {
                throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
            }
            switch (action[0]) {
            case 1:
                stack.push(symbol);
                vstack.push(lexer.yytext);
                lstack.push(lexer.yylloc);
                stack.push(action[1]);
                symbol = null;
                if (!preErrorSymbol) {
                    yyleng = lexer.yyleng;
                    yytext = lexer.yytext;
                    yylineno = lexer.yylineno;
                    yyloc = lexer.yylloc;
                    if (recovering > 0) {
                        recovering--;
                    }
                } else {
                    symbol = preErrorSymbol;
                    preErrorSymbol = null;
                }
                break;
            case 2:
                len = this.productions_[action[1]][1];
                yyval.$ = vstack[vstack.length - len];
                yyval._$ = {
                    first_line: lstack[lstack.length - (len || 1)].first_line,
                    last_line: lstack[lstack.length - 1].last_line,
                    first_column: lstack[lstack.length - (len || 1)].first_column,
                    last_column: lstack[lstack.length - 1].last_column
                };
                if (ranges) {
                    yyval._$.range = [
                        lstack[lstack.length - (len || 1)].range[0],
                        lstack[lstack.length - 1].range[1]
                    ];
                }
                r = this.performAction.apply(yyval, [
                    yytext,
                    yyleng,
                    yylineno,
                    sharedState.yy,
                    action[1],
                    vstack,
                    lstack
                ].concat(args));
                if (typeof r !== 'undefined') {
                    return r;
                }
                if (len) {
                    stack = stack.slice(0, -1 * len * 2);
                    vstack = vstack.slice(0, -1 * len);
                    lstack = lstack.slice(0, -1 * len);
                }
                stack.push(this.productions_[action[1]][0]);
                vstack.push(yyval.$);
                lstack.push(yyval._$);
                newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                stack.push(newState);
                break;
            case 3:
                return true;
            }
        }
        return true;
    }};
    /* generated by jison-lex 0.3.4 */
    var lexer = (function(){
    var lexer = ({
    
    EOF:1,
    
    parseError:function parseError(str, hash) {
            if (this.yy.parser) {
                this.yy.parser.parseError(str, hash);
            } else {
                throw new Error(str);
            }
        },
    
    // resets the lexer, sets new input
    setInput:function (input, yy) {
            this.yy = yy || this.yy || {};
            this._input = input;
            this._more = this._backtrack = this.done = false;
            this.yylineno = this.yyleng = 0;
            this.yytext = this.matched = this.match = '';
            this.conditionStack = ['INITIAL'];
            this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
            };
            if (this.options.ranges) {
                this.yylloc.range = [0,0];
            }
            this.offset = 0;
            return this;
        },
    
    // consumes and returns one char from the input
    input:function () {
            var ch = this._input[0];
            this.yytext += ch;
            this.yyleng++;
            this.offset++;
            this.match += ch;
            this.matched += ch;
            var lines = ch.match(/(?:\r\n?|\n).*/g);
            if (lines) {
                this.yylineno++;
                this.yylloc.last_line++;
            } else {
                this.yylloc.last_column++;
            }
            if (this.options.ranges) {
                this.yylloc.range[1]++;
            }
    
            this._input = this._input.slice(1);
            return ch;
        },
    
    // unshifts one char (or a string) into the input
    unput:function (ch) {
            var len = ch.length;
            var lines = ch.split(/(?:\r\n?|\n)/g);
    
            this._input = ch + this._input;
            this.yytext = this.yytext.substr(0, this.yytext.length - len);
            //this.yyleng -= len;
            this.offset -= len;
            var oldLines = this.match.split(/(?:\r\n?|\n)/g);
            this.match = this.match.substr(0, this.match.length - 1);
            this.matched = this.matched.substr(0, this.matched.length - 1);
    
            if (lines.length - 1) {
                this.yylineno -= lines.length - 1;
            }
            var r = this.yylloc.range;
    
            this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: lines ?
                    (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                     + oldLines[oldLines.length - lines.length].length - lines[0].length :
                  this.yylloc.first_column - len
            };
    
            if (this.options.ranges) {
                this.yylloc.range = [r[0], r[0] + this.yyleng - len];
            }
            this.yyleng = this.yytext.length;
            return this;
        },
    
    // When called from action, caches matched text and appends it on next action
    more:function () {
            this._more = true;
            return this;
        },
    
    // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
    reject:function () {
            if (this.options.backtrack_lexer) {
                this._backtrack = true;
            } else {
                return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
    
            }
            return this;
        },
    
    // retain first n characters of the match
    less:function (n) {
            this.unput(this.match.slice(n));
        },
    
    // displays already matched input, i.e. for error messages
    pastInput:function () {
            var past = this.matched.substr(0, this.matched.length - this.match.length);
            return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
        },
    
    // displays upcoming input, i.e. for error messages
    upcomingInput:function () {
            var next = this.match;
            if (next.length < 20) {
                next += this._input.substr(0, 20-next.length);
            }
            return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
        },
    
    // displays the character position where the lexing error occurred, i.e. for error messages
    showPosition:function () {
            var pre = this.pastInput();
            var c = new Array(pre.length + 1).join("-");
            return pre + this.upcomingInput() + "\n" + c + "^";
        },
    
    // test the lexed token: return FALSE when not a match, otherwise return token
    test_match:function(match, indexed_rule) {
            var token,
                lines,
                backup;
    
            if (this.options.backtrack_lexer) {
                // save context
                backup = {
                    yylineno: this.yylineno,
                    yylloc: {
                        first_line: this.yylloc.first_line,
                        last_line: this.last_line,
                        first_column: this.yylloc.first_column,
                        last_column: this.yylloc.last_column
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                };
                if (this.options.ranges) {
                    backup.yylloc.range = this.yylloc.range.slice(0);
                }
            }
    
            lines = match[0].match(/(?:\r\n?|\n).*/g);
            if (lines) {
                this.yylineno += lines.length;
            }
            this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: lines ?
                             lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                             this.yylloc.last_column + match[0].length
            };
            this.yytext += match[0];
            this.match += match[0];
            this.matches = match;
            this.yyleng = this.yytext.length;
            if (this.options.ranges) {
                this.yylloc.range = [this.offset, this.offset += this.yyleng];
            }
            this._more = false;
            this._backtrack = false;
            this._input = this._input.slice(match[0].length);
            this.matched += match[0];
            token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
            if (this.done && this._input) {
                this.done = false;
            }
            if (token) {
                return token;
            } else if (this._backtrack) {
                // recover context
                for (var k in backup) {
                    this[k] = backup[k];
                }
                return false; // rule action called reject() implying the next rule should be tested instead.
            }
            return false;
        },
    
    // return next match in input
    next:function () {
            if (this.done) {
                return this.EOF;
            }
            if (!this._input) {
                this.done = true;
            }
    
            var token,
                match,
                tempMatch,
                index;
            if (!this._more) {
                this.yytext = '';
                this.match = '';
            }
            var rules = this._currentRules();
            for (var i = 0; i < rules.length; i++) {
                tempMatch = this._input.match(this.rules[rules[i]]);
                if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                    match = tempMatch;
                    index = i;
                    if (this.options.backtrack_lexer) {
                        token = this.test_match(tempMatch, rules[i]);
                        if (token !== false) {
                            return token;
                        } else if (this._backtrack) {
                            match = false;
                            continue; // rule action called reject() implying a rule MISmatch.
                        } else {
                            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        }
                    } else if (!this.options.flex) {
                        break;
                    }
                }
            }
            if (match) {
                token = this.test_match(match, rules[index]);
                if (token !== false) {
                    return token;
                }
                // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                return false;
            }
            if (this._input === "") {
                return this.EOF;
            } else {
                return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
            }
        },
    
    // return next match that has a token
    lex:function lex () {
            var r = this.next();
            if (r) {
                return r;
            } else {
                return this.lex();
            }
        },
    
    // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
    begin:function begin (condition) {
            this.conditionStack.push(condition);
        },
    
    // pop the previously active lexer condition state off the condition stack
    popState:function popState () {
            var n = this.conditionStack.length - 1;
            if (n > 0) {
                return this.conditionStack.pop();
            } else {
                return this.conditionStack[0];
            }
        },
    
    // produce the lexer rule set which is active for the currently active lexer condition state
    _currentRules:function _currentRules () {
            if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
            } else {
                return this.conditions["INITIAL"].rules;
            }
        },
    
    // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
    topState:function topState (n) {
            n = this.conditionStack.length - 1 - Math.abs(n || 0);
            if (n >= 0) {
                return this.conditionStack[n];
            } else {
                return "INITIAL";
            }
        },
    
    // alias for begin(condition)
    pushState:function pushState (condition) {
            this.begin(condition);
        },
    
    // return the number of states currently on the stack
    stateStackSize:function stateStackSize() {
            return this.conditionStack.length;
        },
    options: {},
    performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
    var YYSTATE=YY_START;
    switch($avoiding_name_collisions) {
    case 0:/* skip whitespace */
    break;
    case 1:return 35
    break;
    case 2:return 34
    break;
    case 3:return 36
    break;
    case 4:return 39
    break;
    case 5:return 38
    break;
    case 6:return 37
    break;
    case 7:return 33
    break;
    case 8:return 32
    break;
    case 9:return 44
    break;
    case 10:return 45
    break;
    case 11:return 43
    break;
    case 12:return 57
    break;
    case 13:return 56
    break;
    case 14:return 50
    break;
    case 15:return 55
    break;
    case 16:return 55
    break;
    case 17:return 49
    break;
    case 18:return 58
    break;
    case 19:return 60
    break;
    case 20:return 59
    break;
    case 21:return 42
    break;
    case 22:return 61
    break;
    case 23:return 61
    break;
    case 24:return 29
    break;
    case 25:return 5
    break;
    case 26:return 'INVALID'
    break;
    }
    },
    rules: [/^(?:\s+)/,/^(?:Add\b)/,/^(?:Noop\b)/,/^(?:Delete\b)/,/^(?:UpdateList\b)/,/^(?:Update\b)/,/^(?:Replace\b)/,/^(?:InsertResource\b)/,/^(?:DeleteResource\b)/,/^(?:\()/,/^(?:\))/,/^(?:\.\.)/,/^(?:\^\^)/,/^(?:@[a-zA-Z]+(-[a-zA-Z0-9]+)*)/,/^(?:_:b[0-9]+)/,/^(?:"([^\u0022\u005C]|\\"|\\n|\\\\|\\u[0-9A-Z]{4})*")/,/^(?:'([^\u0022\u005C]|\\"|\\n|\\\\|\\u[0-9A-Z]{4})*')/,/^(?:<[^<>" {}|\\^`]+>)/,/^(?:[+-][0-9]+\.[0-9]+)/,/^(?:[+-][0-9]+)/,/^(?:[0-9]+\.[0-9]+)/,/^(?:[0-9]+)/,/^(?:false\b)/,/^(?:true\b)/,/^(?:\.)/,/^(?:$)/,/^(?:.)/],
    conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26],"inclusive":true}}
    });
    return lexer;
    })();
    parser.lexer = lexer;
    function Parser () {
      this.yy = {};
    }
    Parser.prototype = parser;parser.Parser = Parser;
    return new Parser;
    })();
    
    
    if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
    exports.parser = jisonLdpatch;
    exports.Parser = jisonLdpatch.Parser;
    exports.parse = function () { return jisonLdpatch.parse.apply(jisonLdpatch, arguments); };
    /*exports.main = function commonjsMain (args) {
        if (!args[1]) {
            console.log('Usage: '+args[0]+' FILE');
            process.exit(1);
        }
        var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
        return exports.parser.parse(source);
    };*/
    if (typeof module !== 'undefined' && require.main === module) {
      exports.main(process.argv.slice(1));
    }
    }
            
export default jisonLdpatch;
